<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="ordersOneStryker"
      :items-length="totalItems"
      :search="search"
      :loading="loadingDatatables"
      v-model:expanded="expanded"
      show-expand
      single-expand
      @update:sortBy="toSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>

          <import-file-dialog :table="'ordersOneStryker'"></import-file-dialog>
          <v-tooltip
            location="top"
            text="Recalculer les colonnes personnalisées"
          >
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                class="mb-2 mr-2"
                color="#ffb500"
                size="large"
                @click="recalculateColumns"
              >
                {{ mdiRefresh }}
              </v-icon>
            </template>
          </v-tooltip>
        </v-toolbar>
      </template>

      <template v-slot:item.data-table-expand="{ item }">
        <v-icon
          @click="toggleExpand(item.id)"
          :loading="loadingDetails && selectedOrder === item.id"
          >{{ expanded.includes(item.id) ? mdiChevronUp : mdiChevronDown }}
        </v-icon>
      </template>

      <!-- estlint-disable-next-line -->
      <template v-slot:expanded-row="{ columns, item }">
        <tr v-if="expanded.includes(item.id)">
          <td :colspan="columns.length">
            <v-sheet elevation="9" class="mt-3 mb-3">
              <v-table>
                <thead>
                  <tr class="grey lighten-4">
                    <th>{{ $t("reference") }}</th>
                    <th>{{ $t("description") }}</th>
                    <th>{{ $t("price") }}</th>
                    <th>{{ $t("quantity") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(product, index) in details"
                    :key="index"
                    class="grey lighten-4"
                  >
                    <td>
                      {{ product.reference }}
                    </td>
                    <td>
                      {{ product.description }}
                    </td>
                    <td>
                      {{ product.unitPrice }}
                    </td>
                    <td>
                      {{ product.quantity }}
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-sheet>
          </td>
        </tr>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" color="error" @click="confirmDelete(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'ordersOneStryker'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-order-one-stryker
      :modelDialog="orderOneStrykerDialog"
      @close="orderOneStrykerDialog = false"
    ></add-edit-order-one-stryker>

    <!-- Dialog de confirmation de suppression -->
    <v-dialog v-model="dialogDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirmer la suppression</v-card-title>
        <v-card-text>
          <v-alert type="warning" variant="tonal" class="mb-4">
            Cette action est irréversible
          </v-alert>
          <p>Êtes-vous sûr de vouloir supprimer cette commande ?</p>
          <v-list v-if="itemToDelete" density="compact" class="mt-3">
            <v-list-item v-if="itemToDelete.customer">
              <v-list-item-title>Client</v-list-item-title>
              <v-list-item-subtitle>
                {{ itemToDelete.customer.name }} (N°:
                {{ itemToDelete.customer.number }})
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Numéro de commande</v-list-item-title>
              <v-list-item-subtitle>
                {{ itemToDelete.orderNumber }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="itemToDelete.totalAmount">
              <v-list-item-title>Montant total</v-list-item-title>
              <v-list-item-subtitle>
                {{ itemToDelete.totalAmount }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
          <p class="mt-3 text-caption text-medium-emphasis">
            Tous les détails de la commande seront supprimés et les points du
            contrat seront automatiquement recalculés.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="dialogDelete = false">Annuler</v-btn>
          <v-btn
            color="error"
            variant="elevated"
            @click="deleteOrder"
            :loading="deleting"
          >
            Supprimer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  mdiPencil,
  mdiDelete,
  mdiMagnify,
  mdiAccountPlus,
  mdiChevronUp,
  mdiChevronDown,
  mdiRefresh,
} from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import ImportFileDialog from "./ImportFileDialog.vue";
import AddEditOrderOneStryker from "./admin/AddEditOrderOneStryker.vue";
import paginate from "@/mixins/paginations";
import { mapState } from "vuex";

export default {
  name: "OrderOneStrykerAdmin",
  components: {
    ImportFileDialog,
    PaginationDynamic,
    AddEditOrderOneStryker,
  },
  mixins: [paginate],
  data() {
    return {
      mdiPencil,
      mdiDelete,
      mdiMagnify,
      mdiAccountPlus,
      mdiChevronUp,
      mdiChevronDown,
      mdiRefresh,
      dialog: false,
      dialogDelete: false,
      orderOneStrykerDialog: false,
      selectedOrder: null, // Stocke l'ID en attente d'expansion
      loadingDetails: false, // Indique si on attend les détails
      expanded: [],
      itemToDelete: null,
      deleting: false,
      headers: [
        {
          title: this.$t("admin.customer-number"),
          align: "start",
          sortable: false,
          key: "customer.number",
        },
        {
          title: this.$t("admin.customer-name"),
          key: "customer.name",
        },
        { title: this.$t("order-number"), key: "orderNumber" },
        { title: this.$t("total"), key: "totalAmount" },
        { title: this.$t("actions"), key: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState({
      ordersOneStryker: (state) => state.ordersOneStryker.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
    }),
    search: {
      get() {
        return this.$store.state.paginations.search;
      },
      set(value) {
        this.$store.commit("paginations/setSearch", value);
      },
    },
    details: {
      get() {
        return this.$store.state.ordersOneStryker.details;
      },
    },
  },

  watch: {
    selectedOrder(newOrder) {
      if (newOrder !== null) {
        this.getDetails(newOrder);
      }
    },
  },

  methods: {
    recalculateColumns() {
      if (confirm(this.$t("alert.confirm.recalculate"))) {
        this.$store
          .dispatch("ordersOneStryker/recalculateColumns")
          .then((response) => {
            this.$store.dispatch("showSnackbar", {
              message: response.data,
              color: "success",
            });
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.generic"),
              color: "error",
            });
          });
      }
    },
    getDetails(orderNumber) {
      if (!orderNumber) return;
      this.loadingDetails = true;
      this.$store
        .dispatch("ordersOneStryker/getDetails", orderNumber)
        .then(() => {
          this.expanded = [orderNumber]; // Développe uniquement après l'appel API
        })
        .finally(() => {
          this.loadingDetails = false;
        });
    },
    toggleExpand(orderNumber) {
      if (this.loadingDetails) return;

      if (this.expanded.includes(orderNumber)) {
        this.expanded = [];
        this.$store.commit("ordersOneStryker/setDetails", []);
      } else {
        this.expanded = [orderNumber]; // Développe immédiatement
        this.selectedOrder = orderNumber; // Déclenche l'appel API
      }
    },
    toSort(item) {
      this.sortBy(item, "ordersOneStryker");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "ordersOneStryker");
    },
    editItem(item) {
      this.$store.commit("ordersOneStryker/setEditedId", item.id);
      this.$store.commit(
        "ordersOneStryker/setEditedItem",
        Object.assign({}, item),
      );
      this.orderOneStrykerDialog = true;
    },
    /**
     * Confirme la suppression d'une commande
     */
    confirmDelete(item) {
      this.itemToDelete = item;
      this.dialogDelete = true;
    },
    /**
     * Supprime une commande
     */
    deleteOrder() {
      if (!this.itemToDelete || !this.itemToDelete.id) return;

      this.deleting = true;
      this.$store
        .dispatch("ordersOneStryker/deleteOrder", this.itemToDelete.id)
        .then(() => {
          this.$store.dispatch("showSnackbar", {
            message:
              "Commande supprimée avec succès. Les points ont été recalculés.",
            color: "success",
          });
          this.dialogDelete = false;
          this.itemToDelete = null;
          this.toSearchBack(this.search, 0);
        })
        .catch((error) => {
          let errorMessage = "Erreur lors de la suppression de la commande";

          if (error.response?.status === 403) {
            errorMessage =
              "Vous n'avez pas les droits pour effectuer cette action";
          } else if (error.response?.status === 404) {
            errorMessage =
              "Cette commande n'existe plus ou a déjà été supprimée";
          }

          this.$store.dispatch("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        })
        .finally(() => {
          this.deleting = false;
        });
    },
  },
};
</script>

<style scoped>
/* Styles spécifiques au composant ici */
</style>
